// ======================================================================
// File Name       : ChangePasswordContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Form, Col, Button } from 'react-bootstrap';

import FormControlPassword from '../components/FormControlPassword';
import MessageView from '../components/MessageView';
import {
  VALIDATE_TYPE,
  LO_SUPER_USER,
  SUPER_USER,
  MODE,
  PASS_STRENGTH_TYPE,
} from '../constants/index';
import { HIDE_MESSAGE } from '../constants/actionTypes/message';

import { userEdit } from '../actions/UserAction';
import { superUserEdit } from '../actions/SuperUserAction';
import * as SessionStorageUtils from '../utils/SessionStorageUtils';
import { LOGIN_TYPE } from '../constants/LoginConstant';
import * as Path from '../constants/PathConstants';
import { initAppDataFromAuthedInfo } from '../actions/AuthAction';
import { setGTMConfig } from '../utils/PageUtils';
import { ADMIN_OEM_LOGIN_URL } from '../constants';

class ChangePasswordContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      password: '',
      passwordConfirm: '',
    };

    this.handleChangePass = this.handleChangePass.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  componentWillMount() {
    setGTMConfig();
  }

  /**
   * handle text input change
   */
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  /**
   * Check validate input
   */
  validForm() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  /**
   * handle OK button
   */
  handleChangePass() {
    const valid = this.validForm();
    if (!valid) {
      return;
    }
    const authedUser = { ...this.props.authedUser };
    const { authCd, enterpriseId, enterpriseCd, userInfo } = authedUser;
    const param = {
      enterpriseId,
      authCd,
      editType: MODE.EDIT_MODE,
    };
    const self = this;
    if (enterpriseCd) {
      param.superuserInfo = {
        superuserSecernId: userInfo.userSecernId,
        superuserName: userInfo.userName,
        userSecernId: userInfo.userSecernId,
        afterPassword: this.state.password,
        relationEnterpriseCd: enterpriseCd,
        loginId: userInfo.loginId,
        password: this.state.password,
        passwordChangeFlag: 0,
      };
      // call superuser api
      this.props.dispatch(superUserEdit(param)).then(() => {
        userInfo.passwordChangeFlag = 0;
        initAppDataFromAuthedInfo(authedUser);
        self.props.history.push(Path.SERVICE_LOGIN_LIST);
      });
    } else {
      param.userInfo = {
        userSecernId: userInfo.userSecernId,
        userName: userInfo.userName,
        afterPassword: this.state.password,
        loginId: userInfo.loginId,
        password: this.state.password,
        passwordChangeFlag: 0,
      };
      // call user api
      this.props.dispatch(userEdit(param)).then(() => {
        userInfo.passwordChangeFlag = 0;
        initAppDataFromAuthedInfo(authedUser);
        self.props.history.push(Path.TOP_LIST);
      });
    }
  }

  render() {
    const { logined, authedUser: { enterpriseCd, userInfo }, message } = this.props;
    this.refsToValidate = [];
    if (!logined) {
      // Step9.0.0 START
      const loginId = SessionStorageUtils.getByKey('loginId');
      if (!loginId) {
        window.location.href = ADMIN_OEM_LOGIN_URL;
        return <div />;
      }
      this.props.history.push("/");
      return <div />;
      // Step9.0.0 END
    }

    if (!userInfo.passwordChangeFlag) {
      if (enterpriseCd) {
        this.props.history.push('/serviceLogin');
      } else {
        this.props.history.push('/top');
      }
    }

    return (
      <Col className="container elastic">
        <Col className="margin-top-20 max-width-650">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleChangePass();
            }}
            className='form-horizontal'>
            <Form.Group className="form-info form-service">
              <Col sm={12} className="text-center">
                <h1>
                  <strong>パスワード変更画面</strong>
                </h1>
              </Col>
            </Form.Group>
            <FormControlPassword
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              required
              maxLength={256}
              onChange={this.handleInputChange}
              value={this.state.password}
              name="password"
              label="パスワード"
              type={VALIDATE_TYPE.PASSWORD}
              labelSize={4}
              inputSize={8}
              isChangePassword
              passStrType={PASS_STRENGTH_TYPE.STRONG}
            />
            <FormControlPassword
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              required
              maxLength={256}
              onChange={this.handleInputChange}
              passwordConfirm={this.state.password}
              value={this.state.passwordConfirm}
              name="passwordConfirm"
              type={VALIDATE_TYPE.PASSWORD_CONFIRM}
              label="パスワード（確認）"
              labelSize={4}
              inputSize={8}
              isChangePassword
              confirmPassword
              showAbout // sprint_20230418 #9
            />
            <Col sm={12} className="text-center">
              <MessageView
                message={message}
                onDismiss={() => {
                  this.props.dispatch({
                    type: HIDE_MESSAGE,
                  });
                }}
              />
            </Col>
            <Col sm={12} className="text-center margin-top-10">
              <Button type="submit" className="btn-96">
                OK
              </Button>
            </Col>
          </Form>
        </Col>
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { logined, authedUser } = state.authed;
  const { message } = state;
  return {
    authedUser,
    logined,
    superUser: state.superUser,
    message,
  };
};
export default connect(mapStateToProps)(ChangePasswordContainer);
